__turbopack_context__.v({
  "bundle-banner-section": "index-module-scss-module__A4InCG__bundle-banner-section",
  "callout": "index-module-scss-module__A4InCG__callout",
  "cta": "index-module-scss-module__A4InCG__cta",
  "demo-phone": "index-module-scss-module__A4InCG__demo-phone",
  "end-of-intro-pricing-countdown-and-warning": "index-module-scss-module__A4InCG__end-of-intro-pricing-countdown-and-warning",
  "end-of-intro-pricing-hero": "index-module-scss-module__A4InCG__end-of-intro-pricing-hero",
  "entries": "index-module-scss-module__A4InCG__entries",
  "faq": "index-module-scss-module__A4InCG__faq",
  "faq-wrapper": "index-module-scss-module__A4InCG__faq-wrapper",
  "features": "index-module-scss-module__A4InCG__features",
  "gray-bg": "index-module-scss-module__A4InCG__gray-bg",
  "headline": "index-module-scss-module__A4InCG__headline",
  "hero": "index-module-scss-module__A4InCG__hero",
  "how-it-works": "index-module-scss-module__A4InCG__how-it-works",
  "how-it-works-wrapper": "index-module-scss-module__A4InCG__how-it-works-wrapper",
  "lead": "index-module-scss-module__A4InCG__lead",
  "non-premium-country": "index-module-scss-module__A4InCG__non-premium-country",
  "page-break": "index-module-scss-module__A4InCG__page-break",
  "plan-comparison": "index-module-scss-module__A4InCG__plan-comparison",
  "plans": "index-module-scss-module__A4InCG__plans",
  "read-more": "index-module-scss-module__A4InCG__read-more",
  "reviews-container": "index-module-scss-module__A4InCG__reviews-container",
  "social-proof": "index-module-scss-module__A4InCG__social-proof",
  "step": "index-module-scss-module__A4InCG__step",
  "steps": "index-module-scss-module__A4InCG__steps",
  "testimonials-wrapper": "index-module-scss-module__A4InCG__testimonials-wrapper",
  "use-cases": "index-module-scss-module__A4InCG__use-cases",
  "use-cases-wrapper": "index-module-scss-module__A4InCG__use-cases-wrapper",
});
